import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import M3Card from 'components/M3/M3Card';

type OverviewProps = {};

const Overview: React.FC<OverviewProps> = () => {
  return (
    <Box id='overview'>
      <Typography
        mt={4}
        fontSize={{
          xs: '30px',
          sm: '40px',
          md: '57px',
        }}
        fontWeight={600}
        lineHeight={1}
        mb={{
          xs: 3,
        }}
        whiteSpace='nowrap'
      >
        Our Founder “explains”
      </Typography>
      <M3Card
        sx={{
          bgcolor: 'transparent',
          maxWidth: {
            xs: '300px',
            sm: '400px',
            md: '550px',
            lg: '850px',
          },
          mt: 5,
        }}
        noHover
      >
        <div
          style={{
            height: 0,
            position: 'relative',
            paddingBottom: '56.25%',
            margin: 'auto',
          }}
        >
          <iframe
            src='https://www.loom.com/embed/6caa4e8bbaff4afbaecc98609b94e37f?sid=da2843f5-e733-4010-8671-42f737effe8c'
            allowFullScreen
            style={{
              border: 0,
              margin: 0,
              padding: 0,
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              position: 'absolute',
            }}
          ></iframe>
        </div>
      </M3Card>
      <br />
      <Typography
        fontSize='16px'
        fontWeight={400}
        lineHeight='24px'
        gutterBottom
      >
        Path securely collects and processes your work data to pinpoint where
        you excel and where you can grow. This isn't about funneling you into
        any job; it's about finding where you'll make the most impact and feel
        the most fulfilled.
      </Typography>
      <Typography
        fontSize='16px'
        fontWeight={400}
        lineHeight='24px'
        gutterBottom
      >
        See how your tasks translate into marketable skills and identify
        opportunities for growth.
      </Typography>
      <Typography
        fontSize='16px'
        fontWeight={400}
        lineHeight='24px'
        gutterBottom
      >
        Participate in our Beta to co-create a future where you're not just
        seeking a job, but becoming the architect of your future.
      </Typography>
    </Box>
  );
};

export default Overview;
